import { useCallback, useEffect, useState } from "react";
import { format } from "date-fns";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Input } from "@/components/ui/input";
import { useApi, fmtDate, errMsg } from "@/lib/api";

export const AdminSchedule = () => {
  const api = useApi();
  const [items, setItems] = useState([]);
  const [day, setDay] = useState();
  const [reason, setReason] = useState("");
  const load = useCallback(() => api("get", "/admin/blocked-dates").then(setItems).catch(() => {}), [api]);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    try { await api("post", "/admin/blocked-dates", { date: format(day, "yyyy-MM-dd"), reason }); toast.success("Day blocked"); setDay(undefined); setReason(""); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (d) => { await api("delete", `/admin/blocked-dates/${d}`); load(); };

  return (
    <div className="grid gap-6 lg:grid-cols-[auto_1fr]">
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <p className="text-sm font-semibold text-slate-600">Block a day (holiday, conference, leave). Parents won't be able to book it.</p>
        <div data-testid="admin-block-calendar"><Calendar mode="single" selected={day} onSelect={setDay} disabled={(d) => d < new Date(new Date().toDateString())} /></div>
        <Input placeholder="Reason (optional)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="admin-block-reason" />
        <button disabled={!day} onClick={add} data-testid="admin-block-save" className="mt-3 w-full rounded-full bg-teal-600 py-2.5 text-sm font-bold text-white disabled:opacity-40">Block {day ? format(day, "d MMM") : "day"}</button>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="admin-blocked-list">
        <h3 className="text-lg font-semibold">Blocked days</h3>
        {items.length === 0 && <p className="mt-3 text-sm text-slate-500">No blocked days. Sundays are always closed.</p>}
        <div className="mt-3 divide-y divide-slate-100">
          {items.map((b) => (
            <div key={b.date} className="flex items-center justify-between py-3 text-sm">
              <span><b>{fmtDate(b.date)}</b> {b.reason && <span className="text-slate-500">· {b.reason}</span>}</span>
              <button onClick={() => remove(b.date)} data-testid="admin-unblock" aria-label="Unblock"><Trash2 className="h-4 w-4 text-rose-600" /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
